/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DownloadAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function DownloadAction({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Data/Content/Actions/Content/DownloadAction"
  
}) {
let tabSelectedStatementsMergedDownloadedValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.statements.merged.downloaded',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type={tabSelectedStatementsMergedDownloadedValueData ? "ghost" : "secondary"}
 size="small"
 block={true}
 onClick={onClick}
 data="tab.selected.statements.merged.downloaded"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Download"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}